import { render, staticRenderFns } from "./Comune.vue?vue&type=template&id=1a7a4d82&"
import script from "./Comune.vue?vue&type=script&lang=js&"
export * from "./Comune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports